import * as actionTypes from "../actionTypes";
import * as statuses from "../../statuses";

const initialState = {
  savingStatus: statuses.STATUS_IDLE,
};

function reducer(state = initialState, action) {
  switch (action.type) {
    case actionTypes.SAVE_WASTE_ACTIVITY:
      return {
        ...state,
        savingStatus: statuses.STATUS_IN_PROGRESS,
      };

    case actionTypes.SAVE_WASTE_ACTIVITY_FAILED:
    case actionTypes.SAVE_WASTE_ACTIVITY_SUCCEED:
      return {
        ...state,
        savingStatus: statuses.STATUS_DONE,
      };

    case actionTypes.RESET_WASTE_ACTIVITY_STATUS:
      return {
        ...state,
        savingStatus: statuses.STATUS_IDLE,
      };
    default:
      return state;
  }
}

export default reducer;
